import { Injectable } from '@angular/core';
import { firstValueFrom, Observable, timeout } from 'rxjs';
import { Network } from '@capacitor/network';
import { PromptService } from '../promtp-service/prompt.service';

@Injectable({
  providedIn: 'root',
})
export class BaseApiService {

  constructor(protected _promptService: PromptService) { }

  /**
   * Standard wrapper to:
   * - Check network connectivity
   * - Apply a timeout to the API observable
   * - Convert to a Promise
   *
   * The caller decides how to handle null (typically by returning cached data or an empty result).
   */
  protected async callApi<T>(
    source$: Observable<T>,
    timeoutMs: number,
    context: string,
  ): Promise<T | null> {

    const status = await Network.getStatus();
    if (!status.connected) {
      return null;
    }

    try {
      const result = await firstValueFrom(
        source$.pipe(timeout(timeoutMs)),
      );
      return result;
    } catch (error) {
      await this._promptService.showNetworkConnectionError(error, context);
      return null;
    }
  }
}


